module.exports = __webpack_public_path__ + "static/media/artist.c943dfef.jpg";